const url = "/api/v1/cancellation_reasons";

export type CancellationReasonsCreateParams = {
  slug: string;
  details: string;
};

export const cancellationReasonsCreateQuery = (
  params: CancellationReasonsCreateParams,
) => ({
  url,
  method: "POST",
  body: params,
});
